import { MOBILE_MAX, useRecentSearches } from '@property.com.au/ui-kit';
import { FunctionComponent, useState } from 'react';
import { trackModalImpression } from '../../analytics/event-tracking/trackModalImpression';
import { mapCommuteSearchCTAButtonToProps } from './helpers/mapCommuteSearchCTAButtonToProps';
import { getCommuteScreenStaticData } from './CommuteAndLocationModalCommuteScreen/helpers/getCommuteScreenStaticData';
import { CommuteAndLocationModalCommuteScreen } from './CommuteAndLocationModalCommuteScreen/CommuteAndLocationModalCommuteScreen';
import { getLocationScreenStaticData } from './CommuteAndLocationModalLocationScreen/helpers/getLocationScreenStaticData';
import { CommuteAndLocationModalLocationScreen } from './CommuteAndLocationModalLocationScreen/CommuteAndLocationModalLocationScreen';

type CommuteAndLocationModalScreen = 'LOCATION' | 'COMMUTE';

interface CommuteAndLocationModalProps {
  onClose: () => void;
  searchQuery: string;
  initialScreen: CommuteAndLocationModalScreen;
  locationScreen: {
    title: string;
    subtitle: string;
  };
  commuteScreen: {
    title: string;
    subtitle: string;
    currentSearchPlaceName?: string | null;
  };
  saveRecentLocationSearch: ReturnType<typeof useRecentSearches>['saveRecentLocationSearch'];
}

export const CommuteAndLocationModal: FunctionComponent<CommuteAndLocationModalProps> = ({
  onClose,
  initialScreen,
  locationScreen,
  commuteScreen,
  searchQuery,
  saveRecentLocationSearch,
}) => {
  const [screen, setScreen] = useState<CommuteAndLocationModalScreen>(initialScreen);

  const { locationSearchButtonLabel, pointOfInterestSuggest } = getCommuteScreenStaticData();

  const { commuteSearchCTAButton } = getLocationScreenStaticData();

  const { currentSearchPlaceName } = commuteScreen;

  const isModalFullscreen = window.innerWidth <= MOBILE_MAX;

  return screen === 'LOCATION' ? (
    <CommuteAndLocationModalLocationScreen
      onClose={onClose}
      searchQuery={searchQuery}
      saveRecentLocationSearch={saveRecentLocationSearch}
      title={locationScreen.title}
      subtitle={locationScreen.subtitle}
      commuteSearchCTAButton={{
        ...mapCommuteSearchCTAButtonToProps(commuteSearchCTAButton),
        onClick: () => {
          setScreen('COMMUTE');

          trackModalImpression({
            modal_name: 'location',
            screen_name: 'location_search_location_screen',
            in_page_source: 'commute_cta',
            modal_is_fullscreen: isModalFullscreen,
          });
        },
      }}
    />
  ) : (
    <CommuteAndLocationModalCommuteScreen
      onClose={onClose}
      title={commuteScreen.title}
      subtitle={commuteScreen.subtitle}
      locationSearchButton={{
        label: locationSearchButtonLabel,
        onClick: () => {
          setScreen(`LOCATION`);

          trackModalImpression({
            modal_name: 'commute',
            screen_name: 'commute_search_point_of_interest_search_screen',
            in_page_source: 'location_cta',
            modal_is_fullscreen: isModalFullscreen,
          });
        },
      }}
      pointOfInterestSuggest={{ ...pointOfInterestSuggest, currentSearchPlaceName }}
      searchQuery={searchQuery}
    />
  );
};
